import React from 'react';
import { Text } from '../Text';
const Heading = (props) => React.createElement(Text, Object.assign({ as: 'h3' }, props));
Heading.displayName = 'Heading';
Heading.h1 = (props) => React.createElement(Heading, Object.assign({ as: 'h1', textShadowSize: 'md' }, props));
Heading.h2 = (props) => React.createElement(Heading, Object.assign({ as: 'h2', textShadowSize: 'md' }, props));
Heading.h3 = (props) => React.createElement(Heading, Object.assign({ as: 'h3', textShadowSize: 'sm' }, props));
Heading.h4 = (props) => React.createElement(Heading, Object.assign({ as: 'h4', textShadowSize: 'sm' }, props));
Heading.h5 = (props) => React.createElement(Heading, Object.assign({ as: 'h5', textShadowSize: 'sm' }, props));
Heading.h6 = (props) => React.createElement(Heading, Object.assign({ as: 'h6', textShadowSize: 'sm' }, props));
export default Heading;
//# sourceMappingURL=Heading.js.map